import { CoverageEvent } from '../models/event.model';

export const COVERAGE_EVENTS: CoverageEvent[] = [
  {
    id: '1',
    name: 'Mulheres maravilhosas que empreendem',
    category: 'Cobertura ao ar livre',
    imageUrl: '/assets/28.jpeg',
    accent: 'rosa',
    coverageUrl:
      'https://drive.google.com/drive/folders/1GwWFSsrnhvVSJbRELlgoH3TBDYi2ezjm?usp=drive_link',
  },
  {
    id: '2',
    name: 'Coletivas Games',
    category: 'Evento esportivo',
    imageUrl: '/assets/27.png',
    accent: 'rosa',
    coverageUrl: 'https://drive.google.com/drive/folders/1hucmvO0B02nUtYiXRkDFWJNSclhgeffi?usp=sharing',
  },
  {
    id: '3',
    name: '30 anos Linear Alumínio',
    category: 'Evento corporativo',
    imageUrl: '/assets/26.png',
    accent: 'rosa',
    coverageUrl: 'https://photos.app.goo.gl/CtctK36M51YtLaFQ6',
  },
  {
    id: '4',
    name: 'Festival do Japão em Minas',
    category: 'Criação de conteúdo',
    imageUrl: '/assets/24.png',
    accent: 'rosa',
    coverageUrl: 'https://photos.app.goo.gl/ouAgLRFhj8BwccuY9',
  },
  {
    id: '5',
    name: 'Coletivas da Brasil',
    category: 'Aulão especial',
    imageUrl: '/assets/25.png',
    accent: 'rosa',
    coverageUrl: 'https://photos.app.goo.gl/gPyTQAGCELXRBot58',
  },
];

export const COVERAGE_BUDGET_WHATSAPP_URL =
  'https://wa.me/5531997241539?text=Ol%C3%A1%21%20Vi%20a%20equipe%20da%20Loba%20na%20cobertura%20e%20gostaria%20de%20mais%20informa%C3%A7%C3%B5es%20sobre%20seus%20servi%C3%A7os%21';
